import React, {useEffect, useState} from 'react'
import {Pipeline, TriggerPipelineOnClick, useEnvValue} from '@morningtrain/react-helpers'
import { Translation } from '@morningtrain/react-translations'
import * as Auth from '@morningtrain/react-auth'
import { SubmitFormOnPipe } from '@morningtrain/react-resources'
import ValidateAllItemsHasHoldingsOnPipe from 'widgets/inventory/ValidateAllItemsHasHoldingsOnPipe'
import WhenOrderIsDraft from 'pages/app/inventory/order/partials/WhenOrderIsDraft'
import * as UI from 'ui'
import { WhenIsNotPiping, WhenIsPiping } from '@morningtrain/react-pipelines'

export default function CompleteOrder (props) {
  let errorMinOrderPrice = useEnvValue('globals.inventory.error_min_order_price', false)
  const [disableCompleteOrder, setDisableCompleteOrder] = useState(false)
  useEffect(() => {
    setDisableCompleteOrder(errorMinOrderPrice[0] > 0 || errorMinOrderPrice[0] === true )
  }, [errorMinOrderPrice])
  return (
    <WhenOrderIsDraft>
      <Auth.Can permission='api.inventory.order.store'>
        <Pipeline>
          <WhenIsNotPiping>
            <TriggerPipelineOnClick>
                <UI.Button disabled={disableCompleteOrder}>
                  <Translation name='actions.complete_order'/>
                </UI.Button>
            </TriggerPipelineOnClick>
          </WhenIsNotPiping>
          <WhenIsPiping>
            <UI.Button disabled>
              <Translation name='actions.complete_order' />
            </UI.Button>
          </WhenIsPiping>
          {/*<ValidateAllItemsHasHoldingsOnPipe />*/}
          <SubmitFormOnPipe data={{ status: 'completed' }} />
        </Pipeline>
      </Auth.Can>
    </WhenOrderIsDraft>
  )
}
